import { TZDate } from '@date-fns/tz';
import { format } from 'date-fns';

/**
 * The calendar date (`YYYY-MM-DD`) an instant falls on in a time zone — "today" at the
 * venue rather than in UTC, which is already tomorrow on a US evening. Falls back to the
 * UTC date for an unknown or missing time zone.
 */
const getZonedDateString = (
  timeZone: string | null | undefined,
  instant: Date | number = new Date(),
): string => {
  const zoned = timeZone ? TZDate.tz(timeZone, +instant) : null;
  if (!zoned || Number.isNaN(zoned.getTime())) {
    return new Date(instant).toISOString().substring(0, 10);
  }
  return format(zoned, 'yyyy-MM-dd');
};

export default getZonedDateString;
